import {useMutation} from 'react-query'

import {useFeaturesState} from '../../../../Organisms/Features'
import {
  ORDER_CREATE_API_PATH,
  V2_ORDER_REQUESTS_API_PATH
} from '../../../../Organisms/OrderIntake/OrderIntake.action'
import {mutations} from '../../mutations'
import {hubQueryClient} from '../../QueryProvider'

export const usePostOrderRequestCollectionV2 = () => {
  const {getFeature} = useFeaturesState()
  const enableOrderCreateApi = !!getFeature('EnableOrderCreateApi')
  const apiPath = enableOrderCreateApi ? ORDER_CREATE_API_PATH : V2_ORDER_REQUESTS_API_PATH

  return useMutation(
    (params: Parameters<typeof mutations.postOrderRequestCollectionV2>[0]) =>
      mutations.postOrderRequestCollectionV2({...params, apiPath}),
    {
      onMutate: async () => {
        await hubQueryClient.invalidateQueries('orderRequests')
      }
    }
  )
}
